"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTournamentsRequest = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const constants_1 = require("../constants");
const buildTournamentsRequest = ({ locale, includeSubsports, sportIds, searchQuery, }) => {
    return {
        locale,
        includeSubsports,
        eventStatuses: constants_1.eventStatuses,
        sportIds,
        searchQuery,
        searchQueryFields: [betweb_openapi_axios_1.SearchQueryField.TournamentName],
        eventHasLineOutcomes: false,
        pageSize: 200,
    };
};
exports.buildTournamentsRequest = buildTournamentsRequest;
//# sourceMappingURL=buildTournamentsRequest.js.map